export const Like = '👍';
export const Angry = '😠';
export const Sad = '🙁';
export const Laugh = '😄';
export const Heart = '❤️';
export const Surprised = '😲';
